module.exports = __webpack_public_path__ + "img/BINDI 2 GREEN.40bafe5.svg";